import { createStyles, makeStyles, Theme } from '@material-ui/core';
import classNames from 'classnames';
import React from 'react';

import { colorPalette, TextSizesEnum } from '../../../../theme';
import { PlexTypography } from '../../../shared/primitives/PlexTypography';

interface Props {
  count?: number;
  className?: string;
}

export const NotificationBadge = React.memo(({ count, className }: Props) => {
  const classes = useStyles();
  if (!count) {
    return null;
  }
  return (
    <div className={classNames(classes.root, className)}>
      <PlexTypography className={classes.text} text={count} size={TextSizesEnum.XSmall} />
    </div>
  );
});

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: colorPalette.red._400,
      borderRadius: 6,
      height: 18,
      minWidth: 18,
    },
    text: {
      color: '#fff',
      fontWeight: 'bold',
      letterSpacing: '0.5px',
      paddingLeft: 3,
      paddingRight: 3,
    },
  })
);
